import Vue from 'vue'
import * as utils from './common' // 导入公共方法

// 将公共方法挂载到 Vue.prototype 上
Object.keys(utils).forEach((key) => {
  Vue.prototype[`$${key}`] = utils[key]
})
